import script from "./StickyCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./StickyCard.vue?vue&type=script&lang=ts&setup=true"

import "./StickyCard.vue?vue&type=style&index=0&id=b49000a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b49000a0"]])

export default __exports__